import React from "react";
import { PreviewAltCard } from "../../Component";
import { Icon } from "../../Component";
import moment from "moment";

const ActivityFeed = ({ title, items, loading, maxItems = 5 }) => {
  const getActivityIcon = (type) => {
    const icons = {
      quote: "article",
      user: "users",
      clinic: "home",
      partner: "plus-medi",
      enterprise: "building",
      employee: "users",
      broker: "user",
      contact: "mail",
    };
    return icons[type] || "circle";
  };

  const getActivityColor = (type) => {
    const colors = {
      quote: "bg-success-dim",
      user: "bg-primary-dim",
      clinic: "bg-info-dim",
      partner: "bg-warning-dim",
      enterprise: "bg-purple-dim",
      employee: "bg-blue-dim",
      broker: "bg-orange-dim",
      contact: "bg-pink-dim",
    };
    return colors[type] || "bg-light";
  };

  const formatTime = (time) => {
    if (!time) return "Il y a quelques instants";
    
    // Si c'est une string ISO
    if (typeof time === "string") {
      const momentTime = moment(time);
      if (momentTime.isValid()) {
        return momentTime.fromNow();
      }
    }
    
    // Si c'est déjà formaté
    return time;
  };

  const displayItems = items && Array.isArray(items) ? items.slice(0, maxItems) : [];

  return (
    <PreviewAltCard className="card-bordered h-100">
      <div className="card-title-group mb-3">
        <div className="card-title">
          <h6 className="title">{title || "Recent activity"}</h6>
        </div>
      </div>
      <div className="activity-feed">
        {loading ? (
          <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "200px" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Chargement...</span>
            </div>
          </div>
        ) : displayItems.length > 0 ? (
          <ul className="nk-activity">
            {displayItems.map((item, index) => (
              <li className="nk-activity-item" key={item._id || item.id || `activity-${index}`}>
                <div className="nk-activity-media">
                  <div className={`icon ${getActivityColor(item.type)}`}>
                    <Icon name={getActivityIcon(item.type)}></Icon>
                  </div>
                </div>
                <div className="nk-activity-data">
                  <div className="label">
                    {item.action === "created" && "Créé"}
                    {item.action === "updated" && "Modifié"}
                    {item.action === "deleted" && "Supprimé"}
                    {item.action === "suspended" && "Suspended"}
                    {item.action === "activated" && "Activé"}
                    {!item.action && "Action"}
                  </div>
                  <div className="text">
                    {item.message || item.description || `${item.type} ${item.name || item.title || ""}`}
                  </div>
                  <div className="time">
                    {formatTime(item.time || item.createdAt || item.timestamp)}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-center text-muted py-4">
            <p>No recent activity</p>
          </div>
        )}
      </div>
    </PreviewAltCard>
  );
};

export default ActivityFeed;

